import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import GamingTech from './components/GamingTech';
import HowToGuides from './components/HowToGuides';
import WhatsHot from './components/WhatsHot';
import Newsletter from './components/Newsletter';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <GamingTech />
        <HowToGuides />
        <WhatsHot />
        <Newsletter />
      </main>
      <Footer />
    </div>
  );
}

export default App;
